import styled from "styled-components"

export const TitlesContainer = styled.section`

    height: 60%;
    width: 80%;
    display: flex;
    flex-direction: column;

`